import React, {useCallback, useState} from 'react';
import PropTypes from 'prop-types';
import ISA315ItAppScotBodyItAppItem from './ISA315ItAppScotBodyItAppItem';
import BodySpecialFetchContainer from '../BodySpecialFetchContainer';
import Utility from '../../../../../../../util/utilityfunctions';
import {useSelector} from 'react-redux';
import CreateEditEntityModal from '../../../../../../Common/EntityCrud/CreateEditEntityModal';

export default function ISA315ItAppScotBodyItAppList({
	className,
	bodyId,
	allIds: itApplicationIds,
	filters,
	overrideFilters
}) {
	const [showModal, setShowModal] = useState(false);
	const [entityData, setEntityData] = useState({});

	const handleOnDelete = () => {
		//If we are removing the last item of the current page, we need to go back to the previous page.
		if (itApplicationIds.length === 1 && filters.page > 1) {
			overrideFilters && overrideFilters({page: --filters.page});
		}
	};

	const ids = useSelector((state) => {
		if (itApplicationIds && itApplicationIds.length > 0) {
			let itApplications = itApplicationIds.map((id) => state.bodiesSpecial.itApplications?.byId[id]);
			Utility.sortAlphaNumeric(itApplications, 'itApplicationName');
			return itApplications.map((itApplication) => itApplication.id);
		}
		return [];
	});

	const onDropdownOptionClick = useCallback(
		(data) => {
			setEntityData(data);
			setShowModal(true);
		},
		[showModal, entityData]
	);

	return (
		<>
			{showModal && (
				<CreateEditEntityModal
					entityType={entityData?.entityId}
					entityId={entityData?.entityUId}
					showCreateEditEntityModal={showModal}
					setShowCreateEditEntityModal={setShowModal}
				/>
			)}
			<BodySpecialFetchContainer className={`isa315-itapp-scot-body-itapp-list customScrollbar ${className}`}>
				{ids.map((itApplicationId) => {
					return (
						<ISA315ItAppScotBodyItAppItem
							bodyId={bodyId}
							itApplicationId={itApplicationId}
							key={itApplicationId}
							onDelete={handleOnDelete}
							onDropdownOptionClick={onDropdownOptionClick}
						/>
					);
				})}
			</BodySpecialFetchContainer>
		</>
	);
}

ISA315ItAppScotBodyItAppList.propTypes = {
	className: PropTypes.string,
	bodyId: PropTypes.number.isRequired,
	allIds: PropTypes.arrayOf(PropTypes.number),
	filters: PropTypes.shape({
		page: PropTypes.number,
		pageSize: PropTypes.number
	}),
	overrideFilters: PropTypes.func
};

ISA315ItAppScotBodyItAppList.defaultProps = {
	className: 'isa315-itapp-scot-body-itapp-list customScrollbar',
	bodyId: 0,
	allIds: []
};
